import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AccordionVM } from '../accordion/accordion.model';
import { Observable } from 'rxjs';
import { Constants } from '../app.constants';

@Injectable({
  providedIn: 'root'
})
export class VideosService {

  constructor(private httpClient: HttpClient) { }

  get(): Observable<AccordionVM[]> {
    return this.httpClient.get<AccordionVM[]>(Constants.videos);
  }
}
